import { Images } from '@/assets/images';
import { DocTypeEnum, REGEX } from '@/constant';
import { cls, dayjs, formatDate } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	employerNameKo: '',
	foreignWorkerNameKo: '',
	deductionTotalAmount: '',
	installmentCountKo: '',
	installmentCountEn: '',
	signedDate: '',
	employerSignatureName: '',
	employerSignature: '',
	workerSignatureName: '',
	workerSignature: '',
	consenterName: '',
	consenterNameEn: '',
	consenterElectronicSignature: '',
	employerDeductionAgree: '1',
	workerDeductionAgree: '1',
	deductionOption: '',
};

const EMPLOYER_DEDUCTION_AGREE_OPTIONS = ['1', '0'];
const WORKER_DEDUCTION_AGREE_OPTIONS = ['1', '0'];
const DEDUCTION_OPTIONS = ['1', '0'];

type IValues = typeof initializeValue;

export const ACCIDENT_INSURANCE_DEDUCTION_AGREEMENT_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.ARF_12
> = {
	initializeValue,
	title: '상해보험료 공제동의서',
	mapPropToValues: ({ refTableName, franchiseData, applicantData }) => {
		return {
			signedDate: formatDate(dayjs()),
			employerNameKo: franchiseData?.employerName,
			foreignWorkerNameKo: applicantData?.fullName,
			employerSignatureName: franchiseData?.employerName,
			workerSignatureName: franchiseData?.employerName,
			consenterName: applicantData?.fullName,
			consenterNameEn: applicantData?.fullName,
		};
	},
	pages: [
		{
			background: {
				src: Images.formAccidentInsuranceDeductionAgreement,
				className: 'template',
				dataSource: Images.formAccidentInsuranceDeductionAgreement,
			},
			textAreas: [
				(values, index) => ({
					name: 'employerNameKo',
					maxHeight: 18,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[188px] left-[145px] !h-[21px] w-[143px]'
						// values?.employerNameKo && 'bg-white'
					),
					maxLength: 15,
				}),
				(values, index) => ({
					name: 'foreignWorkerNameKo',
					maxHeight: 18,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[188px] left-[463px] !h-[21px] w-[185px]'
						// values?.foreignWorkerNameKo && 'bg-white'
					),
					maxLength: 30,
				}),
				(values, index) => ({
					name: 'employerNameKo',
					maxHeight: 20,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[249px] left-[343px] !h-[21px] w-[134px]'
						// values?.employerNameKo && 'bg-white'
					),
					maxLength: 15,
				}),
				(values, index) => ({
					name: 'foreignWorkerNameKo',
					maxHeight: 20,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[269px] left-[70px] !h-[21px] w-[208px]'
						// values?.foreignWorkerNameKo && 'bg-white'
					),
					maxLength: 30,
				}),
				(values, index) => ({
					name: 'deductionTotalAmount',
					maxHeight: 20,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[391px] left-[339px] !h-[21px] w-[112px]'
						// values?.deductionTotalAmount && 'bg-white'
					),
					maxLength: 11,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					currency: true,
				}),
				(values, index) => ({
					name: 'deductionTotalAmount',
					maxHeight: 20,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[433px] left-[95px] !h-[21px] w-[152px]'
						// values?.deductionTotalAmount && 'bg-white'
					),
					maxLength: 11,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					currency: true,
				}),
				(values, index) => ({
					name: 'installmentCountKo',
					maxHeight: 20,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[463px] left-[489px] !h-[21px] w-[34px]'
						// values?.installmentCountKo && 'bg-white'
					),
					maxLength: 3,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					disabled: values?.deductionOption !== '0',
				}),
				(values, index) => ({
					name: 'installmentCountKo',
					maxHeight: 20,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[506px] left-[400px] !h-[19px] w-[43px]'
						// values?.installmentCountKo && 'bg-white'
					),
					maxLength: 3,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					disabled: values?.deductionOption !== '0',
				}),
				(values, index) => ({
					name: 'employerSignatureName',
					maxHeight: 24,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[928px] left-[275px] !h-[21px] w-[179px]'
						// values?.employerSignatureName && 'bg-white'
					),
					maxLength: 18,
				}),
				(values, index) => ({
					name: 'workerSignatureName',
					maxHeight: 24,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[949px] left-[275px] !h-[21px] w-[179px]'
						// values?.workerSignatureName && 'bg-white'
					),
					maxLength: 18,
				}),
				(values, index) => ({
					name: 'consenterName',
					maxHeight: 24,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[988px] left-[276px] !h-[21px] w-[179px]'
						// values?.consenterName && 'bg-white'
					),
					maxLength: 16,
				}),
				(values, index) => ({
					name: 'consenterNameEn',
					maxHeight: 24,
					className: 'text-[12px] text-left',
					containerClassName: cls(
						'absolute top-[1009px] left-[276px] !h-[21px] w-[179px]'
						// values?.consenterNameEn && 'bg-white'
					),
					maxLength: 16,
				}),
			],
			checkboxes: [
				{
					name: 'deductionOption',
					classNames: [
						'absolute top-[460px] left-[207px] w-6 h-6',
						'absolute top-[460px] left-[319px] w-6 h-6',
					],
					iconType: 'checkbox',
					options: DEDUCTION_OPTIONS,
					getResetKey: (value: string) => {
						return ['installmentCountKo'];
					},
				},
				{
					name: 'deductionOption',
					classNames: [
						'absolute top-[481px] left-[304px] w-6 h-6',
						'absolute top-[481px] left-[561px] w-6 h-6',
					],
					iconType: 'checkbox',
					options: DEDUCTION_OPTIONS,
					getResetKey: (value: string) => {
						return ['installmentCountKo'];
					},
				},
				{
					name: 'employerDeductionAgree',
					classNames: [
						'absolute top-[586px] left-[85px] w-6 h-6',
						'absolute top-[586px] left-[222px] w-6 h-6',
					],
					iconType: 'checkbox',
					options: EMPLOYER_DEDUCTION_AGREE_OPTIONS,
				},

				{
					name: 'workerDeductionAgree',
					classNames: [
						'absolute top-[659px] left-[85px] w-6 h-6',
						'absolute top-[659px] left-[214px] w-6 h-6',
					],
					iconType: 'checkbox',
					options: WORKER_DEDUCTION_AGREE_OPTIONS,
				},
				{
					name: 'employerDeductionAgree',
					classNames: [
						'absolute top-[693px] left-[288px] w-6 h-6',
						'absolute top-[693px] left-[387px] w-6 h-6',
					],
					iconType: 'checkbox',
					options: EMPLOYER_DEDUCTION_AGREE_OPTIONS,
				},

				{
					name: 'workerDeductionAgree',
					classNames: [
						'absolute top-[809px] left-[422px] w-6 h-6',
						'absolute top-[809px] left-[525px] w-6 h-6',
					],
					iconType: 'checkbox',
					options: WORKER_DEDUCTION_AGREE_OPTIONS,
				},
			],
			datePickers: [
				{
					name: 'signedDate',
					segmentedInputs: true,
					format: 'YYYY                       MM                            DD',
					containerClassName: 'absolute top-[899px] left-[399px]',
					style: { fontSize: '14px' },
					boxStyle: { marginTop: '-11px' },
				},
			],
			signatures: [
				{
					name: 'employerSignature',
					className: 'absolute top-[922px] left-[485px] !h-[48px] w-[125px]',
				},
				{
					name: 'consenterElectronicSignature',
					className: 'absolute top-[981px] left-[485px] !h-[48px] w-[125px]',
				},
			],
			highlightBoxes: [
				{
					name: 'employerNameKo',
					className: 'top-[184px] left-[145px] !h-[21px] w-[143px]',
				},
				{
					name: 'foreignWorkerNameKo',
					className: 'top-[184px] left-[463px] !h-[21px] w-[185px]',
				},
				{
					name: 'employerNameKo',
					className: 'top-[245px] left-[343px] !h-[21px] w-[134px]',
				},
				{
					name: 'foreignWorkerNameKo',
					className: 'top-[265px] left-[70px] !h-[21px] w-[208px]',
				},
				{
					name: 'deductionTotalAmount',
					className: 'top-[390px] left-[80px] !h-[21px] w-[251px]',
				},
				{
					name: 'deductionTotalAmount',
					className: 'top-[430px] left-[95px] !h-[21px] w-[152px]',
				},
				{
					name: 'installmentCountKo',
					className: 'top-[460px] left-[489px] !h-[21px] w-[34px]',
				},
				{
					name: 'installmentCountKo',
					className: 'top-[503px] left-[400px] !h-[21px] w-[43px]',
				},
				// Checkbox
				{
					name: 'deductionOption',
					className: 'top-[462px] left-[80px] !h-[21px] w-[119px]',
				},
				// {
				// 	name: 'deductionOption',
				// 	className: 'top-[483px] left-[305px] !h-[21px] w-[405px]',
				// },
				{
					name: 'employerDeductionAgree',
					className: 'top-[587px] left-[87px] !h-[21px] w-[307px]',
				},
				{
					name: 'workerDeductionAgree',
					className: 'top-[660px] left-[87px] !h-[21px] w-[300px]',
				},
				{
					name: 'employerDeductionAgree',
					className: 'top-[695px] left-[278px] !h-[21px] w-[263px]',
				},
				{
					name: 'workerDeductionAgree',
					className: 'top-[810px] left-[413px] !h-[21px] w-[272px]',
				},
				// End Checkbox
				{
					name: 'signedDate',
					className: 'top-[889px] left-[397px] !h-[21px] w-[311px]',
				},
				{
					name: 'employerSignatureName',
					className: 'top-[928px] left-[275px] !h-[21px] w-[179px]',
				},
				{
					name: 'employerSignature',
					className: 'top-[928px] left-[483px] !h-[21px] w-[125px]',
				},

				{
					name: 'workerSignatureName',
					className: 'top-[949px] left-[275px] !h-[21px] w-[179px]',
				},
				{
					name: 'workerSignature',
					className: 'top-[949px] left-[456px] !h-[21px] w-[157px]',
				},
				{
					name: 'consenterName',
					className: 'top-[988px] left-[276px] !h-[21px] w-[179px]',
				},
				{
					name: 'consenterElectronicSignature',
					className: 'top-[988px] left-[484px] !h-[21px] w-[125px]',
				},
				{
					name: 'consenterNameEn',
					className: 'top-[1009px] left-[276px] !h-[21px] w-[179px]',
				},
				{
					name: 'consenterElectronicSignature',
					className: 'top-[1009px] left-[456px] !h-[21px] w-[163px]',
				},
			],
		},
	],
};
